export const outbrainMixins: Record<string, Partial<OutbrainProps>> = {
  AR_35: {
    widgetId: 'AR_35',
  },
  AR_36: {
    widgetId: 'AR_36',
  },
  AR_39: {
    widgetId: 'AR_39',
  },
  AR_37: {
    widgetId: 'AR_37',
  },
  AR_45: {
    widgetId: 'AR_45',
  },
  AR_38: {
    widgetId: 'AR_38',
  },
  AR_44: {
    widgetId: 'AR_44',
  },
  AR_27: {
    widgetId: 'AR_27',
  },
  SB_2: {
    //siderail
    widgetId: 'SB_2',
  },
  AR_31: {
    //below thumbnails
    widgetId: 'AR_31',
  },
}

export const placementsToOutbrainWidgets: Record<string, string> = {
  // Section placements
  sectiontab_r1_c1: 'AR_39',
  sectiontab_r1_c3: 'AR_39',
  sectiontab_r1_c4: 'AR_39',
  sectiontab_r1_c5: 'AR_39',
  sectiontab_r2_c2: 'AR_39',
  sectiontab_r2_c4: 'AR_39',
  sectiontab_r3_c1: 'AR_39',
  sectiontab_r3_c3: 'AR_39',
  sectiontab_r3_c4: 'AR_39', // Added for 4-tile layout Row 3 ad
  sectiontab_r3_c5: 'AR_39',
  sectiontab_slider_1: 'AR_27',
  sectiontab_slider_2: 'AR_27',
  sectiontab_slider_3: 'AR_27',
  // Homepage placements
  newtab_r1_c2: 'AR_35',
  newtab_r1_topright: 'AR_36',
  newtab_r2_c1: 'AR_37',
  newtab_r3_right: 'AR_45',
  newtab_r4_c1: 'AR_44',
  newtab_endless_right: 'AR_38',
  newtab_slider_1: 'AR_27',
  newtab_slider_2: 'AR_27',
  // Article page placements
  article_siderail: 'SB_2',
}
